module.exports = "<div class=\"panel panel-default\"><div class=panel-heading><span l10n>{{::adminHotelPanelCtrl.heading}}</span></div><div class=panel-body><div ng-transclude></div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/admin-hotel-panel/admin-hotel-panel.html
// module id = 597
// module chunks = 0